import { render, staticRenderFns } from "./section5.vue?vue&type=template&id=2d3a716d&scoped=true"
import script from "./section5.vue?vue&type=script&lang=js"
export * from "./section5.vue?vue&type=script&lang=js"
import style0 from "./section5.vue?vue&type=style&index=0&id=2d3a716d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a716d",
  null
  
)

export default component.exports